import actions from './action_types.js';
import axios from "axios";

export default {
    [actions.MODAL_GENERATE_BALANCE_SAVE]: function(store, data) {
        return axios.post(data.url, { description: data.description});
    }
}